module.exports = __webpack_public_path__ + "static/media/domain.fd280a78.svg";